import { Component } from '@angular/core';
import {AngularFireAuth} from '@angular/fire/compat/auth';
import {FirebaseService} from '../app/firebase.service';
import {User} from '../app/user';

@Component({
  selector: 'app-konto',
  templateUrl: './konto.component.html',
  styles: []
})
export class KontoComponent {
  user: User;

  constructor(private auth: AngularFireAuth, public service: FirebaseService) {
    service.user.subscribe(user => this.user = user);
  }
}
